import { render, staticRenderFns } from "./modalVerLeecheros.vue?vue&type=template&id=859f3044"
import script from "./modalVerLeecheros.vue?vue&type=script&lang=js"
export * from "./modalVerLeecheros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports